/**
 * @since 2.0.0
 */
import { identity } from "./Function.js";
/**
 * @since 2.0.0
 */
export const unify = identity;
//# sourceMappingURL=Unify.js.map